<template>
    <v-dialog v-model="show" width="500" persistent no-click-animation>
        <div class="Confirm">
            <div class="dialog-header" primary-title>
                {{ $f.tc('confirm') }}
            </div>
            <div style="font-size: 14px; padding: 12px; font-family: 'open sans'">
                <div>{{ message }}</div>
                <div style="font-size: 13px; font-style: italic; margin-top: 4px; color: red" v-if="notice"><strong>*{{$f.tc('notice')}}</strong>: {{ notice }}</div>
            </div>
            <div class="dialog-footer">
                <div class="btn-custom" @click="confirm">
                    {{ $f.tc('confirm') }}
                </div>
                <div class="btn-outline" @click="deny">
                    {{ $f.tc('cancel') }}
                </div>
            </div>
        </div>
    </v-dialog>
</template>
<script>

export default {
    name: 'Confirm',
    data() {
        return {
            show: false,
            promise: null,
            message: '',
            notice: ''
        }
    },
    methods: {
        open(message, notice) {
            this.message = message
            this.notice = notice ? notice : ''
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        confirm() {
            this.show = false
            this.promise.resolve(true)
        },
        deny() {
            this.show = false
            this.promise.reject(false)
        }
    }
}
</script>
<style scoped lang="scss">
.Confirm {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-right: 8px;
    }
}
</style>
